// Department Management Permissions (the office's organisational chart)
//
// 1365-1368 are the central key service's issued numbers, approved in June 2026
// for the dynamic-approval-workflow feature. That feature is abandoned and its
// migration will never run, so `2026_09_18_000005_add_department_permissions.php`
// writes these rows instead — the approval is of the NAME, and the id it issued
// is the row id, which is why these constants and that migration must stay equal.
//
// Two things the batch decides for us:
//
// - The approved edit key is `departments.edit`, so the backend route was renamed
//   off `.update`. The constant keeps the UPDATE name because that is what the
//   row actions call it here; only the backend key changed.
// - `departments.show` (1369) is approved and deliberately unused — Rule #5 in the
//   backend's CLAUDE.md: no `<module>.show`, a detail route is guarded by `index`.
//
// RESTORE was not in that batch — every other module in the backend guards restore
// on its own `*.restore` rather than borrowing `delete`, so it was registered
// separately and approved on 21 September 2026 as 1616. Note it does NOT continue
// the 1365-1369 block: it is a read value, not the next number along.
//
// The department PICKER on the employee form and the department FILTER on the
// HR lists are deliberately not gated on any of these: `/departments-search`
// is un-permissioned on the backend (the `employees-positions-search` and
// `/projects/search` precedent), because choosing a department is not
// restructuring the company.
export const DEPARTMENTS_INDEX = 1365;
export const DEPARTMENTS_CREATE = 1366;
export const DEPARTMENTS_UPDATE = 1367;
export const DEPARTMENTS_DELETE = 1368;
export const DEPARTMENTS_RESTORE = 1616;
